import * as React from 'react';
import * as _ from 'lodash';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { PortfolioAgreementDisclaimer } from './PortfolioAgreementDisclaimer';
import { PortfolioAgreementDisclaimerContext } from './PortfolioAgreementDisclaimerContext';
import { AppState } from '../../types/state/AppState';
import { portfolioAgreementDisclaimerActions } from '../../actions/portfolio-agreement-disclaimer.actions';

interface Props {
    disabled?: boolean;
    onCancel?: () => void;
    children: React.ReactNode;
}

interface ContentProps {
    onCancel?: () => void;
    children: React.ReactNode;
}

const PortfolioAgreementDisclaimerContent: React.FC<ContentProps> = ({ children, onCancel }) => {
    const actionBlockerId = React.useRef(_.uniqueId('portfolio-agreement-disclaimer-content-blocker-'));
    const blocked = React.useContext(PortfolioAgreementDisclaimerContext);
    const dispatch = useDispatch();
    const history = useHistory();
    const popupVisible = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.visible);
    const confirmed = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.confirmed);
    const blockerId = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.blockerId);
    const handleReject = React.useCallback(() => onCancel ? onCancel() : history.replace('/'), [onCancel, history]);

    React.useEffect(() => {
        if (blocked && !popupVisible && confirmed === undefined) {
            dispatch(portfolioAgreementDisclaimerActions.show(actionBlockerId.current, 'Agree'))
        }
    }, [dispatch, blocked, popupVisible, actionBlockerId, confirmed]);

    React.useEffect(() => {
        if (!popupVisible && confirmed === false && actionBlockerId.current === blockerId) {
            handleReject();
            dispatch(portfolioAgreementDisclaimerActions.reset());
        }
    }, [history, popupVisible, confirmed, actionBlockerId, blockerId, dispatch, handleReject]);

    return blocked ? null : <>{children}</>;
};


export const PortfolioAgreementDisclaimerContentBlocker: React.FC<Props> = ({ disabled = false, children, onCancel }) => {
    return (
        <PortfolioAgreementDisclaimer disabled={disabled}>
            {() => (
                <PortfolioAgreementDisclaimerContent onCancel={onCancel}>
                    {children}
                </PortfolioAgreementDisclaimerContent>
            )}
        </PortfolioAgreementDisclaimer>
    );
};
